import { Component, Vue, Ref, Emit } from "vue-property-decorator";
import LeftTree from './components/LeftTree.vue'
import ProcessParametersBody from './components/ProcessParametersBody'
import './components/ProcessParameters.less'
import { WorkStationWorkingConditionParamSettingServiceProxy} from '@/service-proxies/app-v2/workStation.service-proxies'
import { ProcessParametersServiceProxy} from '@/service-proxies/app-v2/mdc.service-proxies'
import dayjs from 'dayjs';
import { exportParameters } from '@/api/api';
const ppsp = new ProcessParametersServiceProxy()
const wscpsp=new WorkStationWorkingConditionParamSettingServiceProxy()
@Component({
  components: {
    LeftTree,
    ProcessParametersBody
  }
})
export default class TimeAnalysis extends Vue {
  @Ref() processParametersBody: ProcessParametersBody
  operationData = []
  tabsdData = []
  processData = []
  workStationId = ''
  selectTime = ''
  chooseIndex = 0
  filter = 1
  getTableTime = ''
  loading = false
  searchValue:any = {}
  workStationName=''

  getTableList() {
    this.loading = true
    const time = this.getSelectTime(this.getTableTime)
    this.operationData = []
    const data = {
      beginTime: dayjs(time[0]).format('YYYY-MM-DD HH:mm:ss'),
      endTime: dayjs(time[1]).format('YYYY-MM-DD HH:mm:ss'),
      workStationId: this.workStationId,
      filter: this.filter
    }
    ppsp.getProcessParameters(data as any).then(res =>{
      console.log(res)
      this.operationData = res
      this.loading = false
    }).catch(() =>{
      this.loading = false
    })
  }

  getWork(){
    wscpsp.getWorkingConditionParams(this.workStationId).then(res=>{
      this.processData=[]
      if(res){
        console.log(res)
        this.processData=res
      }
      else {
        console.log(res)
      }
    })
  }

  getSelectTime(value){
    let time = []
    time = value.split('~')
    return time
  }

  search(value,name) {
    this.workStationName=name
    this.searchValue = value
    this.searchValue['workStationName'] = name
    this.selectTime = value.date
    this.workStationId = value.workStationId
    ppsp.getTimeSlot(value).then(res =>{
      if(res){
        // console.log(res)
        this.tabsdData = res
        this.getTableTime = this.tabsdData[this.chooseIndex]
        this.getTableList()
      }
    })
  }

  handleChange(value){
    this.tabsdData.forEach((res,index) =>{
      if (index === value){
        this.chooseIndex = index
        this.getTableTime = res
        this.getTableList()
      }
    })
  }

  handleShowTypeChange(value){
    this.filter = value
    this.getTableList()
  }

  outPut() {

  }

  changeX(){

  }
  
  export(val){
    var obj={
      data:this.selectTime,
      wcpsList:val,
      workStationId:this.workStationId,
      workStationName:this.workStationName
    }
    exportParameters(obj).then(res=>{
       // 创建隐藏的可下载链接
       var a = document.createElement('a')
       a.download = `${this.$t('page_process_parameters')}.xlsx`
       a.style.display = 'none'
       // 字符内容转变成blob地址
       // var blob = new Blob([res])
       let url = URL.createObjectURL(res)
       a.href = url
       // 触发点击
       document.body.appendChild(a)
       a.click()
       // 然后移除
       URL.revokeObjectURL(url)
       document.body.removeChild(a)
    })
   
  }

  leftTree() {
    return (
      <left-tree onSearch={(value,name) => this.search(value,name)} onOutPut={() => this.outPut()} queryKey="process-parameters"></left-tree>
    )
  }
  
  timeAnalysis() {
    return (
      this.operationData ? 
      <process-parameters-body 
        ref="ProcessParametersBody"
        loading={this.loading}
        tabsdData={this.tabsdData}
        data={this.operationData}
        process={this.processData}
        onChangeTabs={value => this.handleChange(value)}
        onShowTypeChange={value => this.handleShowTypeChange(value)}
        onExport={val => this.export(val)}
        onGetWork={() => this.getWork()}
        >
      </process-parameters-body> : null
    )
  }
  render() {
    return (
      <a-layout class="process-parameters-body" style="height: 100%">
        <a-layout-sider width="360" style="background: #fff; min-width:360px; overflow:auto;" class="no-fix-sider">
          {this.leftTree()}
        </a-layout-sider>
        <div v-resize={'x'}></div>
        <a-layout-content style={{ height: '100%' }}>
          {this.timeAnalysis()}
        </a-layout-content>
      </a-layout>
    )
  }
}
